// this list is from api
export default {
  data: [
    {
      id: "27447",
      name: "Adelaide Crows",
      ReferenceTypeCode: "AFLTEAM",
      ReferenceTypeId: "1602",
      prefix: "afl_team"
    },
    {
      id: "27448",
      name: "Brisbane Lions",
      ReferenceTypeCode: "AFLTEAM",
      ReferenceTypeId: "1602",
      prefix: "afl_team"
    },
    {
      id: "27449",
      name: "Carlton Blues",
      ReferenceTypeCode: "AFLTEAM",
      ReferenceTypeId: "1602",
      prefix: "afl_team"
    },
    {
      id: "27450",
      name: "Collingwood Magpies",
      ReferenceTypeCode: "AFLTEAM",
      ReferenceTypeId: "1602",
      prefix: "afl_team"
    },
    {
      id: "27451",
      name: "Essendon Bombers",
      ReferenceTypeCode: "AFLTEAM",
      ReferenceTypeId: "1602",
      prefix: "afl_team"
    },
    {
      id: "27452",
      name: "Fremantle Dockers",
      ReferenceTypeCode: "AFLTEAM",
      ReferenceTypeId: "1602",
      prefix: "afl_team"
    },
    {
      id: "27453",
      name: "Geelong Cats",
      ReferenceTypeCode: "AFLTEAM",
      ReferenceTypeId: "1602",
      prefix: "afl_team"
    },
    {
      id: "27454",
      name: "Gold Coast Suns",
      ReferenceTypeCode: "AFLTEAM",
      ReferenceTypeId: "1602",
      prefix: "afl_team"
    },
    {
      id: "27455",
      name: "Greater Western Sydney Giants",
      ReferenceTypeCode: "AFLTEAM",
      ReferenceTypeId: "1602",
      prefix: "afl_team"
    },
    {
      id: "27456",
      name: "Hawthorn Hawks",
      ReferenceTypeCode: "AFLTEAM",
      ReferenceTypeId: "1602",
      prefix: "afl_team"
    },
    {
      id: "27457",
      name: "Melbourne Demons",
      ReferenceTypeCode: "AFLTEAM",
      ReferenceTypeId: "1602",
      prefix: "afl_team"
    },
    {
      id: "27458",
      name: "North Melbourne Kangaroos",
      ReferenceTypeCode: "AFLTEAM",
      ReferenceTypeId: "1602",
      prefix: "afl_team"
    },
    {
      id: "27459",
      name: "Port Adelaide Power",
      ReferenceTypeCode: "AFLTEAM",
      ReferenceTypeId: "1602",
      prefix: "afl_team"
    },
    {
      id: "27460",
      name: "Richmond Tigers",
      ReferenceTypeCode: "AFLTEAM",
      ReferenceTypeId: "1602",
      prefix: "afl_team"
    },
    {
      id: "27464",
      name: "St Kilda Saints",
      ReferenceTypeCode: "AFLTEAM",
      ReferenceTypeId: "1602",
      prefix: "afl_team"
    },
    {
      id: "27461",
      name: "Sydney Swans",
      ReferenceTypeCode: "AFLTEAM",
      ReferenceTypeId: "1602",
      prefix: "afl_team"
    },
    {
      id: "27463",
      name: "Western Bulldogs",
      ReferenceTypeCode: "AFLTEAM",
      ReferenceTypeId: "1602",
      prefix: "afl_team"
    },
    {
      id: "27462",
      name: "Westcoast Eagles",
      ReferenceTypeCode: "AFLTEAM",
      ReferenceTypeId: "1602",
      prefix: "afl_team"
    }
  ]
};
